const {registerModule} = window;

class Toc {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    if (!this.isDropdown) {
      this.checkOnLoad();
    }
    this.bindEvents();
    if (!this.isDropdown) {
      this.observeContent();
    }
  }

  bindUI() {
    this.ui = {};
    this.ui.$tocOutside = this.element.querySelector('[data-ref="toc-outside"]');
    this.ui.$tocTitle = this.element.querySelector('[data-ref="toc-title"]');
    this.ui.$tocList = this.element.querySelector('[data-ref="toc-list"]');
    this.ui.$tocItems = [...this.element.querySelectorAll('[data-ref="toc-list-item"]')];
    this.ui.$nav = this.element.querySelector('nav');
    this.isOpen = false;
    this.isDropdown = this.element.classList.contains('toc--dropdown');
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
    this.hash = window.location.hash;
  }

  bindEvents() {
    if (this.isMobile || this.isDropdown) {
      this.ui.$tocTitle.addEventListener('click', this.onClick.bind(this));

      this.ui.$tocItems.forEach(($item) => {
        $item.addEventListener('click', this.onClick.bind(this));
      });
    }
    if (this.ui.$tocOutside) {
      this.ui.$tocOutside.addEventListener('click', this.onClick.bind(this));
    }
  }

  checkOnLoad() {
    if (this.hash === '') return;
    this.current = this.element.querySelector(`[href="${this.hash}"]`);

    this.ui.$tocItems.forEach(($item) => {
      $item.classList.remove('is-active');
    });

    this.current.closest('[data-ref="toc-list-item"]').classList.add('is-active');
  }

  observeContent() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('id');
        const $relatedTocLink = document.querySelector(`.toc__link[href="#${id}"]`);

        if ($relatedTocLink) {
          if (entry.isIntersecting) {
            const $oldActiveToc = document.querySelector('[data-ref="toc-list-item"].is-active');
            const $newActiveToc = $relatedTocLink.closest('[data-ref="toc-list-item"]');

            if ($oldActiveToc && $newActiveToc && $oldActiveToc != $newActiveToc) {
              $oldActiveToc.classList.remove('is-active');
            }

            if ($newActiveToc) $newActiveToc.classList.add('is-active');

            return;
          }

          // on leave
          if (entry.boundingClientRect.top > 0) {
            // left below
            // find previous section if below
            const $currentTocItem = $relatedTocLink.closest('[data-ref="toc-list-item"].is-active');

            if ($currentTocItem) {
              const $$tocItemList = [...$currentTocItem.parentElement.querySelectorAll('[data-ref="toc-list-item"]')];
              const tocItemIndex = $$tocItemList.indexOf($currentTocItem) - 1;

              if (tocItemIndex >= 0) {
                $currentTocItem.classList.remove('is-active');
                $$tocItemList[tocItemIndex].classList.add('is-active');
              }
            }
          }
        }
      });
    }, {rootMargin: '0px 0px -80% 0px', threshold: 0});

    document.querySelectorAll('h2[id], h3[id]').forEach((title) => {
      this.observer.observe(title);
    });
  }

  onClick() {
    if (this.isOpen) {
      this.isOpen = false;
      this.onClose();
    } else {
      this.isOpen = true;
      this.onOpen();
    }
  }

  onOpen() {
    this.ui.$tocList.classList.add('is-open');
    this.ui.$tocOutside?.classList.add('is-open');
    this.ui.$nav?.classList.add('is-open');
  }

  onClose() {
    this.ui.$tocList.classList.remove('is-open');
    this.ui.$tocOutside?.classList.remove('is-open');
    this.ui.$nav?.classList.remove('is-open');
  }
}

registerModule('Toc', Toc);
